import type { OverSiteControllerPeoplePriceInput } from "@/lib/gql/__generated__/graphql";
import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

/**
 * 料金が空欄の料金項目を生成する
 *
 * 料金を空欄（undefined）にしておくことで、未入力のまま保存しようとした場合に
 * zod スキーマの必須チェックで保存をブロックする
 * （デフォルト料金を入れてしまうと、未確認のままその金額で販売される事故につながる）
 */
export const createEmptyPriceItem = (capacityPeopleMaximum: number) =>
	({
		upperNum: {
			isEdited: false,
			value: capacityPeopleMaximum,
		},
		price: {
			amount: {
				isEdited: true,
				// InputNumberField は undefined を空欄として表示する（型上は number のため非nullアサーションで格納する）
				value: undefined!,
			},
			currencyType: {
				isEdited: true,
				value: CurrencyType.Jpy,
			},
		},
	}) satisfies ForAutoGenerator<OverSiteControllerPeoplePriceInput, "">;
